
export enum CostType {
	percentualCost = "percentualCost",
	absoluteCost = "absoluteCost"
}



// WEBPACK FOOTER //
// ./src/services/interfaces/calculator/CostType.ts